<template>
  <div class="problems-btn-wrapper">
    <b-button
      class="w-100 text-left font-weight-bold"
      style="text-overflow: ellipsis; overflow: hidden; white-space: no-wrap;"
      v-for="button in buttons" 
      :key="button.label"
      variant="light"
      @click="scrollTo(button.id)"
    >
      {{ button.label }}
    </b-button>
    <b-button 
      class="font-weight-bold mr-2"
      variant="neon-blue"
      @click="scrollTo('trinpod-server')"
    >
      Solution: TrinPod&trade; Server
    </b-button>
    <b-button 
      class="font-weight-bold"
      variant="neon-blue"
      @click="scrollTo('trinapp-suite')"
    >
      Solution: TrinApp&trade; Suite
    </b-button>
  </div> 
</template>

<script>
export default {
  name: "ProblemsButtons",
  data() {
    return {
      buttons: [
          { label: 'Finding Actionable Information Takes Hours per day', path: '', id: 'find-actionable-info' },
          { label: 'Information in Multiple Incompatible App Silos', path: '', id: 'own-your-info' },
          { label: 'Information Stored Without a Systems Approach', path: '', id: 'systems-approach' },
          { label: 'BIM captures Final Form, but not Function', path: '', id: 'form-follows-function' }, 
          { label: 'Rework from Outdated Document Versions', path: '', id: 'single-source-of-truth' },
        ]
    }
  },
  methods: {
    scrollTo: function(id) {
      document.getElementById(id).scrollIntoView({ behavior: 'smooth' });
    },
	}
}
</script>
